/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $RegistrationDenyRequest = {
  properties: {
    professionalId: {
      type: 'string',
      isRequired: true,
    },
    userId: {
      type: 'string',
      isRequired: true,
    },
    reason: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
